module.exports = __webpack_public_path__ + "img/bcard_2.440f1d12.png";